export default __webpack_public_path__ + "static/media/bi_apple.48d0b8f8.svg";